import React, { useEffect, ReactNode } from 'react';
import { useFavorites } from '../stores/appStore';

interface AppStoreProviderProps {
  children: ReactNode;
}

/**
 * Provider qui s'occupe de l'initialisation du store Zustand
 * ✅ NOUVEAU : Charge les favoris depuis IndexedDB au démarrage
 */
export const AppStoreProvider: React.FC<AppStoreProviderProps> = ({ children }) => {
  const { loadFavorites } = useFavorites();

  useEffect(() => {
    console.log('🚀 AppStoreProvider - Initialisation du state management...');
    
    // ✅ CORRECTION : Délai pour s'assurer qu'IndexedDB est prêt + retry logic
    const initializeFavorites = async () => {
      const maxRetries = 3;
      let retryCount = 0;
      
      while (retryCount < maxRetries) {
        try {
          // Petit délai pour s'assurer qu'IndexedDB est complètement initialisé
          if (retryCount > 0) {
            await new Promise(resolve => setTimeout(resolve, 1000 * retryCount));
          }
          
          await loadFavorites();
          console.log('✅ AppStoreProvider - Favoris initialisés', { retryCount });
          break; // Succès, sortir de la boucle
        } catch (error) {
          retryCount++;
          console.warn(`⚠️ AppStoreProvider - Tentative ${retryCount}/${maxRetries} échouée:`, error);
          
          if (retryCount >= maxRetries) {
            console.error('❌ AppStoreProvider - Impossible d\'initialiser les favoris après', maxRetries, 'tentatives');
          }
        }
      }
    };
    
    // Délai initial pour éviter la race condition avec IndexedDB
    setTimeout(initializeFavorites, 100);
  }, []); // Seulement au montage, jamais re-déclenché

  return <>{children}</>;
}; 